import { Head } from '@inertiajs/react';
import type { AdminDashboardsShow } from '@/types';
import { ApprovedAgeDistribution } from './components/ApprovedAgeDistribution';
import { ApprovedCountryBreakdown } from './components/ApprovedCountryBreakdown';
import { ApprovedStatsCards } from './components/ApprovedStatsCards';
import { CountryParticipants } from './components/CountryParticipants';
import { OnboardingCurve } from './components/OnboardingCurve';
import { ReviewDistribution } from './components/ReviewDistribution';
import { StatsCards } from './components/StatsCards';
import { StatusBreakdown } from './components/StatusBreakdown';
import { SubmissionTimeline } from './components/SubmissionTimeline';

export default function Show({
  event,
  title,
  stats,
  approvedStats,
  submissionTimeline,
  onboardingCurve,
  reviewDistribution,
  countryParticipants,
  statusBreakdown,
}: AdminDashboardsShow) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div>
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Dashboard</h1>
            <p className="text-muted-foreground">{event.name} admin overview</p>
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="font-semibold text-xl">All Applicants</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            <StatsCards stats={stats} />
          </div>

          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <ReviewDistribution distribution={reviewDistribution} />

            <CountryParticipants data={countryParticipants} />
          </div>

          <SubmissionTimeline data={submissionTimeline} />

          <OnboardingCurve curve={onboardingCurve} />

          <StatusBreakdown data={statusBreakdown} />
        </div>

        <div className="space-y-2">
          <h2 className="font-semibold text-xl">Approved Hackers</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            <ApprovedStatsCards stats={approvedStats} />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <ApprovedAgeDistribution stats={approvedStats} />

          <ApprovedCountryBreakdown stats={approvedStats} />
        </div>
      </div>
    </>
  );
}
